import ControlFactory from '@/Factories/ControlFactory';
import ComponentManager from '@/Management/ComponentManager';
import EmbeddedListViewViewModelT from '@/ViewModels/Controls/EmbeddedListViewViewModel';
import EmbeddedListViewT from '@/Controls/EmbeddedListView';
import { IEmbeddedListViewFactoryParameters, IGridControlFactory } from '#/DefaultViewExtensionInterfaces';
import Utilities from '@/Utility/Utilities';

export default class EmbeddedListViewFactory extends ControlFactory implements IGridControlFactory {

    private controlHtmlElement: JQuery;
    private EmbeddedListViewViewModel = ComponentManager.getViewModel<typeof EmbeddedListViewViewModelT>('EmbeddedListViewViewModel');
    private EmbeddedListView = ComponentManager.getControl<typeof EmbeddedListViewT>('EmbeddedListView');
    public isLazy: KnockoutObservable<boolean>;

    public constructor(private params: IEmbeddedListViewFactoryParameters) {
        super(params);

        this.isLazy = this.observableOrDefault(params.lazyLoading, true);
    }

    public getControl(): JQuery {
        this.viewModel = new this.EmbeddedListViewViewModel({
            viewName: this.paramOrDefault(this.params.typeName, '') + '_LV',
            filter: this.paramOrDefault(this.params.filter, ''),
            showFilter: this.paramOrDefault(this.params.showFilter, true),
            showEdit: this.paramOrDefault(this.params.showEdit, true),
            onEdit: this.paramOrDefault(this.params.onEdit, null),
            onBeforeListViewLoaded: this.paramOrDefault(this.params.onBeforeListViewLoaded, null),
            getStorageColumnDefinitionKey: this.paramOrDefault(this.params.getStorageColumnDefinitionKey, null),
            isLazy: this.isLazy,
            isDisplayed: this.isDisplayed,
            parentLocator: this.locator,
            locator: this.detailViewItem.name,
            inheritPersistenceContext: this.paramOrDefault(this.params.inheritPersistenceContext, null),
            disablePrincipalFilter: this.paramOrDefault(this.params.disablePrincipalFilter, null),
            detailViewContext: this.context,
    }) as any;

        const control = new this.EmbeddedListView(this.viewModel as any);
        const tuple = control.getTuple();
        return tuple.control;
    }

    public getContainerPostfix(shouldInitializeData: boolean = true): KnockoutObservable<string> {
        return this.defineComputed(() => {
            const embeddedViewModel = this.viewModel as any as EmbeddedListViewViewModelT;
            if (this.isDisposed || Utilities.isNullOrUndefined(embeddedViewModel?.listView()) || Utilities.isNullOrUndefined(embeddedViewModel.dataGrid))
                return '';

            if (shouldInitializeData && Utilities.isNullOrUndefined(embeddedViewModel.dataGrid.defaultIterator) && Utilities.isNullOrUndefined(embeddedViewModel.dataGrid.iterator())) {
                // Wenn kein defaultIterator f�r eine EmbeddedLV existiert muss ein Iterator erstellt werden
                const filter = embeddedViewModel.dataGrid.getFilterExpression();
                const stringifiedFilter = !_.isEmpty(filter) ? JSON.stringify(filter) : '';
                const iterator = embeddedViewModel.dataGrid.createIterator(stringifiedFilter);

                if (iterator != null) {
                    iterator.then(it => {
                        if (!this.isDisposed)
                        embeddedViewModel.dataGrid.iterator(it);
                    });
                }
                return '';
            }

            if (Utilities.isNullOrUndefined(embeddedViewModel.dataGrid.iterator())) {
                if (Utilities.isNullOrUndefinedOrBlank(embeddedViewModel.dataGrid.staticFilter()))
                    return embeddedViewModel.dataGrid.defaultIterator.fullExtentCount;
                return '...';
            }
            return embeddedViewModel.dataGrid.iterator().fullExtentCount;
        });
    }

    public getContainerPostfixWithoutInit(): KnockoutObservable<string> {
        return this.getContainerPostfix(false);
    }
}

ComponentManager.setFactory('EmbeddedListView', EmbeddedListViewFactory, 'RADPresentation.HTMLClient.DefaultViewExtensions');